module.exports = __webpack_public_path__ + "30305852cff7f07a8515c529f8af7a39.png";